import { Plus } from "lucide-react";
import React from "react";

const TopTapProductAdd = ({
  products,
  setActiveIndex,
  activeIndex,
  handleAddProduct,
}) => {
  return (
    <>
      <div className="bg-white rounded-xl p-3 md:p-4 mb-4">
        <div className="flex items-center gap-3 overflow-x-auto pb-2">
          {products.map((p, i) => {
            const frontImage = Array.isArray(p.images)
              ? p.images.find((img) => img.type === "front")?.urls?.original
              : p.images?.front || null;

            return (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`
        shrink-0 flex items-center gap-3
        px-3 py-2 rounded-lg border transition
        ${
          activeIndex === i
            ? "border-indigo-600 bg-indigo-50"
            : "border-gray-200"
        }
      `}
              >
                <div className="h-12 w-12 rounded-md overflow-hidden bg-gray-100">
                  {frontImage ? (
                    <img
                      src={frontImage}
                      alt=""
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <div className="h-full w-full bg-gray-200" />
                  )}
                </div>

                <span
                  className={`text-sm font-medium whitespace-nowrap ${
                    activeIndex === i ? "text-indigo-700" : "text-gray-700"
                  }`}
                >
                  Product {i + 1}
                </span>
              </button>
            );
          })}

          {/* Add Product */}
          <button
            onClick={handleAddProduct}
            className="shrink-0 flex items-center gap-2 px-3 py-2 border-2 border-dashed border-indigo-300 rounded-lg"
          >
            <div className="h-12 w-12 rounded-lg bg-indigo-100 flex items-center justify-center">
              <Plus size={22} className="text-indigo-600" />
            </div>

            <span className="text-sm text-indigo-600 font-medium">
              Add Product
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default TopTapProductAdd;
